/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomProductExportImportDto } from '../models/pom-product-export-import-dto';
import { ResultDetailsDto } from '../models/result-details-dto';


/**
 * the Product import API
 */
@Injectable({
  providedIn: 'root',
})
export class ProductImportService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation importProduct
   */
  static readonly ImportProductPath = '/product/import';

  /**
   * Import full product and product variants
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importProduct$Response(params: {
    body: PomProductExportImportDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ResultDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductImportService.ImportProductPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResultDetailsDto>;
      })
    );
  }

  /**
   * Import full product and product variants
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importProduct(params: {
    body: PomProductExportImportDto
  },
  context?: HttpContext

): Observable<ResultDetailsDto> {

    return this.importProduct$Response(params,context).pipe(
      map((r: StrictHttpResponse<ResultDetailsDto>) => r.body as ResultDetailsDto)
    );
  }

}
